import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import FriendlyDuration from 'components/FriendlyDuration';
import InlineList from 'components/InlineList';
import Icon from 'components/Icon';
function SectionContentInfo(_ref) {
  var contentItemCount = _ref.contentItemCount,
    sectionDuration = _ref.sectionDuration,
    lockingInfoText = _ref.lockingInfoText,
    _ref$withLockIcon = _ref.withLockIcon,
    withLockIcon = _ref$withLockIcon === void 0 ? false : _ref$withLockIcon;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Box, {
    dimmed: true,
    shrink: true,
    fontSize: "s"
  }, /*#__PURE__*/React.createElement(InlineList, {
    splitBy: "dot",
    display: "inline"
  }, lockingInfoText && /*#__PURE__*/React.createElement(React.Fragment, null, withLockIcon && /*#__PURE__*/React.createElement(Icon, {
    vAlign: true,
    scale: 0,
    name: "lock",
    mr: "xxs"
  }), lockingInfoText), contentItemCount !== undefined && t('playlist_item_count', {
    count: contentItemCount
  }), sectionDuration > 0 && /*#__PURE__*/React.createElement(FriendlyDuration, {
    value: sectionDuration * 60
  })));
}
export default SectionContentInfo;